import { ChangeDetectionStrategy, Component, TrackByFunction } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UtilsService } from '../../../core/services/utils.service';
import { Group } from '../../../core/modules/groups/groups.types';
import { GroupsApiService } from '../../../core/modules/groups/groups-api.service';

@Component({
  selector: 'tax-groups',
  templateUrl: './groups-page.component.html',
  styleUrls: ['./groups-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class GroupsPageComponent {
  readonly groupSearchInput: FormControl<string> = new FormControl<string>('', {
    nonNullable: true,
  });

  readonly groups$: Observable<Group[]>;

  readonly trackById: TrackByFunction<Group> = this.utilService.trackById;

  private readonly groupNameChanged$: Observable<string> = this.groupSearchInput.valueChanges
    .pipe(
      // TODO: change behaviour. On 'enter' press and on clean don't need debounceTime
      startWith(this.groupSearchInput.value),
      debounceTime(1000),
      distinctUntilChanged(),
    );

  constructor(
    private groupsApiService: GroupsApiService,
    private utilService: UtilsService,
  ) {
    this.groups$ = this.groupNameChanged$
      .pipe(
        switchMap(() => this.groupsApiService.fetchGroups(0, this.groupSearchInput.value)),
      );
  }
}
